import * as publicApi from "../../../../service/publicApi";
import React, { useState, useContext } from "react";
import InputV2 from "../../../material/input/InputV2";
import Select from "../../../material/select/Select";
import Map from "../../../material/map/Map";
import { CurrentUserContext } from "../../../../App";
const Laboratory = ({ list, laboratory, onInputChange }) => {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [labDistrictList, setLabDistrictList] = useState([]);
  const [labSubDistrictList, setLabSubDistrictList] = useState([]);

  const getLabDistrictList = async (provinceId) => {
    let res = await publicApi.getDistrictList(provinceId);
    if (res["data"]["code"] === 200) {
      setLabDistrictList(
        res["data"]["district_list"].map((item) => ({
          key: item["district_id"],
          value: item["district_name"],
        })),
      );
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getLabSubDistrictList = async (districtId) => {
    let res = await publicApi.getSubDistrictList(districtId);
    if (res["data"]["code"] === 200) {
      setLabSubDistrictList(
        res["data"]["sub_district_list"].map((item) => ({
          key: item["sub_district_id"],
          value: item["sub_district_name"],
        })),
      );
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <>
      <div className="flex flex-col justify-center items-start w-full gap-[10px] rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px]">
        <h1 className="text-[18px] mb-[10px]">ข้อมูลห้องปฏิบัติการ</h1>
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          ชื่อห้องปฏิบัติการ
          <InputV2
            type="text"
            placeholder="ชื่อห้องปฏิบัติการ"
            value={laboratory.laboratory_name}
            onChangeEvt={(value) => onInputChange("laboratory_name", value)}
          />
        </div>
        <div className="flex flex-row md:flex-col w-full gap-2">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            ที่อยู่
            <InputV2
              type="text"
              placeholder="ที่อยู่"
              value={laboratory.laboratory_address}
              onChangeEvt={(value) =>
                onInputChange("laboratory_address", value)
              }
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            หมู่
            <InputV2
              type="text"
              placeholder="หมู่"
              value={laboratory.laboratory_moo}
              onChangeEvt={(value) => onInputChange("laboratory_moo", value)}
            />
          </div>
        </div>
        <div className="flex flex-row md:flex-col w-full gap-2">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            ซอย
            <InputV2
              type="text"
              placeholder="ซอย"
              value={laboratory.laboratory_soy}
              onChangeEvt={(value) => onInputChange("laboratory_soy", value)}
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            ถนน
            <InputV2
              type="text"
              placeholder="ถนน"
              value={laboratory.laboratory_road}
              onChangeEvt={(value) => onInputChange("laboratory_road", value)}
            />
          </div>
        </div>
        <div className="flex flex-row md:flex-col w-full gap-2">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            <label>จังหวัด</label>
            <Select
              // label="จังหวัด"
              placeholder="จังหวัด"
              value={laboratory.laboratory_provinceId}
              setValue={(e) => {
                onInputChange("laboratory_provinceId", e);
                getLabDistrictList(e);
              }}
              list={list}
            ></Select>
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            <label>อำเภอ</label>
            <Select
              // label="อำเภอ"
              placeholder="อำเภอ"
              value={laboratory.laboratory_district}
              setValue={(e) => {
                onInputChange("laboratory_district", e);
                getLabSubDistrictList(e);
              }}
              list={labDistrictList}
            ></Select>
          </div>
        </div>
        <div className="flex flex-row md:flex-col w-full gap-2">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            <label>ตำบล</label>
            <Select
              // label="ตำบล"
              placeholder="ตำบล"
              value={laboratory.laboratory_subDistrict}
              setValue={(e) => onInputChange("laboratory_subDistrict", e)}
              list={labSubDistrictList}
            ></Select>
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            <label className="mb-[3px]">รหัสไปรษณีย์</label>
            <InputV2
              type="text"
              placeholder="รหัสไปรษณีย์"
              value={laboratory.laboratory_postCode}
              onChangeEvt={(value) =>
                onInputChange("laboratory_postCode", value)
              }
            />
          </div>
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="text-[18px]">ตำแหน่งที่ตั้ง</div>
          <p className="break-words whitespace-normal">
            กรุณารอสักครู่เพื่อให้แผนที่แสดงที่ตั้งปัจจุบันของท่าน
            จากนั้นให้ปักหมุดบนตำแหน่งห้องปฏิบัติการของท่าน
            หรือค้นหาละติจูดและลองจิจูดจาก https://www.google.com/maps
          </p>
        </div>
        <div className="w-full h-[400px]">
          <Map
            latitude={laboratory.latitude}
            longitude={laboratory.longitude}
            onChange={(e) => {
              onInputChange("latitude", e.lat);
              onInputChange("longitude", e.lng);
            }}
          />
        </div>
        <div className="flex flex-row md:flex-col w-full gap-2">
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            Latitude
            <InputV2
              label="Latitude"
              placeholder={"latitude"}
              value={laboratory.latitude}
              onChangeEvt={(value) => onInputChange("latitude", value)}
            ></InputV2>
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
            Longitude
            <InputV2
              label="Longitude"
              placeholder={"longitude"}
              value={laboratory.longitude}
              onChangeEvt={(value) => onInputChange("longitude", value)}
            ></InputV2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Laboratory;
